/* Product card image swipe - mobile only. Requires swiper-bundle.min.js. */

(function () {
  var MOBILE_QUERY = '(max-width: 749px)';

  /**
   * swiper-bundle.min.js and this file are both deferred, so Swiper is normally
   * ready before we need it. Cards injected by AJAX (related products, faceted
   * filtering) can upgrade earlier than that, so wait rather than bail out.
   */
  function whenSwiperReady(callback) {
    if (typeof Swiper !== 'undefined') {
      callback();
      return;
    }

    var attempts = 0;
    var timer = setInterval(function () {
      if (typeof Swiper !== 'undefined') {
        clearInterval(timer);
        callback();
      } else if (++attempts > 100) {
        clearInterval(timer);
      }
    }, 100);
  }

  class CardProductSwipe extends HTMLElement {
    constructor() {
      super();
      this.swiper = null;
      this.observer = null;
      this.mediaQuery = window.matchMedia(MOBILE_QUERY);
      this.handleMediaQueryChange = this.handleMediaQueryChange.bind(this);
      this.handleIntersection = this.handleIntersection.bind(this);
    }

    /**
     * Set up on connect rather than in the constructor: a card moved or
     * re-inserted into the DOM has to be able to initialise again.
     */
    connectedCallback() {
      if (this.mediaQuery.addEventListener) {
        this.mediaQuery.addEventListener('change', this.handleMediaQueryChange);
      } else {
        this.mediaQuery.addListener(this.handleMediaQueryChange);
      }

      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(this.handleIntersection, {
          rootMargin: '0px 0px 200px 0px',
        });
        this.observer.observe(this);
      } else {
        this.handleMediaQueryChange(this.mediaQuery);
      }
    }

    disconnectedCallback() {
      this.destroySwiper();

      if (this.mediaQuery.removeEventListener) {
        this.mediaQuery.removeEventListener('change', this.handleMediaQueryChange);
      } else {
        this.mediaQuery.removeListener(this.handleMediaQueryChange);
      }

      if (this.observer) {
        this.observer.disconnect();
        this.observer = null;
      }
    }

    handleIntersection(entries) {
      var self = this;
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        if (self.observer) self.observer.unobserve(self);
        self.handleMediaQueryChange(self.mediaQuery);
      });
    }

    handleMediaQueryChange(event) {
      if (event.matches) {
        this.initSwiper();
      } else {
        this.destroySwiper();
      }
    }

    initSwiper() {
      if (this.swiper) return;

      var container = this.querySelector('.swiper');
      if (!container) return;

      // Nothing to swipe through with a single image.
      if (container.querySelectorAll('.swiper-slide').length <= 1) return;

      var self = this;
      whenSwiperReady(function () {
        // Conditions may have changed while we were waiting.
        if (self.swiper || !self.isConnected || !self.mediaQuery.matches) return;

        // The progress bar stays hidden until the customer starts dragging.
        var showBar = function () {
          clearTimeout(self.paginationTimer);
          container.classList.add('is-swiping');
        };

        // Kept visible briefly after release so the settled position is readable.
        var hideBar = function () {
          clearTimeout(self.paginationTimer);
          self.paginationTimer = setTimeout(function () {
            container.classList.remove('is-swiping');
          }, 600);
        };

        self.swiper = new Swiper(container, {
          slidesPerView: 1,
          spaceBetween: 0,
          loop: false,
          pagination: {
            el: container.querySelector('.swiper-pagination'),
            type: 'progressbar',
          },
          // Stop a swipe from also registering as a tap on the product link.
          preventClicks: true,
          preventClicksPropagation: true,
          touchStartPreventDefault: false,
          threshold: 10,
          // Hand the gesture back to a parent carousel once we run out of slides,
          // e.g. Featured collection with "swipe on mobile" enabled.
          touchReleaseOnEdges: true,
          resistanceRatio: 0.65,
          watchOverflow: true,
          on: {
            touchStart: showBar,
            sliderMove: showBar,
            touchEnd: hideBar,
            transitionEnd: hideBar,
          },
        });
      });
    }

    destroySwiper() {
      clearTimeout(this.paginationTimer);

      if (this.swiper) {
        this.swiper.destroy(true, true);
        this.swiper = null;
      }

      var container = this.querySelector('.swiper');
      if (container) container.classList.remove('is-swiping');
    }
  }

  if (!customElements.get('card-product-swipe')) {
    customElements.define('card-product-swipe', CardProductSwipe);
  }
})();
